export default __webpack_public_path__ + "static/EnergyLabelLinks1_x2-0f014ed87f076057aa725baf7e618480.png";